import { AudioLines } from "lucide-react";

export function Brand({ context }: { context?: string }) {
  return (
    <a className="brand" href="/" aria-label="Vox">
      <span className="brand-mark" aria-hidden="true">
        <AudioLines size={20} strokeWidth={2.4} />
      </span>
      <span className="brand-name">Vox</span>
      {context ? <span className="brand-context">{context}</span> : null}
    </a>
  );
}
